'use client';
import { createContext } from 'react';
import { CmsClientContextValue } from './types';

export const CmsClientContext = createContext<
  CmsClientContextValue | undefined
>(undefined);
